import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "FormsChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    style:"height: 150px",
    options: ChartOptions.getFormsChartOptions(),
    config: {
        datasets: {
            today: {
                backgroundColor: "#4b54b4",
                borderColor: "#9398d2",
                fill: false,
                tension: 0.1
            },
            yesterday: {
                backgroundColor: "#353b7e",
                borderColor: "#6f76c3",
                fill: false,
                tension: 0.1
            }
        }

    }
}